import { LogoutOutlined } from "@ant-design/icons";
import { Image, Menu } from "antd";
import type { MenuProps } from "antd";
import React from "react";
import { App } from "../App/apps";
import { useAppState } from "../App/state";
import { useAuth } from "../contexts/Auth";
import OpenSpaceLogo from "../statics/images/openspace-logo.png";

import styles from "./NavMenu.module.css";

const Header = () => (
  <div className={styles["white-circle"]}>
    <Image
      className={styles["disperse-logo"]}
      preview={false}
      src={OpenSpaceLogo}
    />
  </div>
);

interface ItemProps {
  app: App;
  name: string;
  icon: React.ComponentType<Partial<Record<string, any>>>;
}

interface NavMenuProps {
  items: ItemProps[];
}

const NavMenu = (props: NavMenuProps) => {
  const auth = useAuth();
  const appState = useAppState();

  const menuItems: MenuProps["items"] = props.items.map(
    ({ name, icon: Icon, app }) => ({
      key: app,
      label: name,
      icon: <Icon />,
      onClick: () => {
        if (appState.app !== app) {
          appState.setApp(app);
        }
      },
    }),
  );

  const logoutItem = {
    key: "logout",
    label: "Logout",
    icon: <LogoutOutlined />,
    onClick: auth.logout,
  };

  return (
    <div className={styles["nav-menu"]}>
      <div>
        <Header />
        {auth.status === "authenticated" && (
          <Menu
            theme="dark"
            selectedKeys={appState.app != null ? [appState.app] : []}
            items={menuItems}
          />
        )}
      </div>
      {auth.status === "authenticated" && (
        <Menu theme="dark" items={[logoutItem]} />
      )}
    </div>
  );
};

export default NavMenu;
